import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { useCurrentNamespace } from '@modules/permissions/composables';

import type {
  IAdminProfileData,
  IAdminProfileDataResponse,
} from '../types';
import {
  ADMIN_PROFILE_SETTINGS_QUERY_KEY,
  ADMIN_PROFILE_SETTINGS_URL,
  PROFILE_SETTINGS_PERMISSIONS,
} from '../constants';

export default function useAdminProfileQuery(): IContextQueryResult<
  IAdminProfileDataResponse,
  Error,
  IAdminProfileData
> {
  const { fetchGet } = useRestClient();
  const { isAdminNamespace } = useCurrentNamespace();

  return useContextQuery<
    IAdminProfileDataResponse,
    Error,
    IAdminProfileData
  >({
    queryKey: [ADMIN_PROFILE_SETTINGS_QUERY_KEY],
    queryFn: ({ signal }) => fetchGet<IAdminProfileDataResponse>(
      ADMIN_PROFILE_SETTINGS_URL,
      {
        signal,
        permission: PROFILE_SETTINGS_PERMISSIONS.SHOW,
      },
    ),
    select: (data) => data.profile,
    enabled: isAdminNamespace,
  });
}
